import { OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import moment from 'moment';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
var TabDeadlineComponent = /** @class */ (function () {
    function TabDeadlineComponent(data, _fuseTranslationLoaderService) {
        this.data = data;
        this._fuseTranslationLoaderService = _fuseTranslationLoaderService;
        this.today = moment();
        this.isAllDatesAsNull = false;
        this.maintenance = data.maintenance;
        this._fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    TabDeadlineComponent.prototype.ngOnInit = function () {
        this.firstVisitDeadlineAt = this.maintenance.firstVisitDeadlineAt ? moment(this.maintenance.firstVisitDeadlineAt).format('DD/MM/YYYY HH:mm') : 'MAINTENANCES.TABS.DEADLINES.WITHOUT_DEADLINE';
        this.firstVisitStartedAt = this.maintenance.firstVisitStartedAt ? moment(this.maintenance.firstVisitStartedAt).format('DD/MM/YYYY HH:mm') : 'MAINTENANCES.TABS.DEADLINES.NOT_STARTED';
        this.deadlineAt = this.maintenance.deadlineAt ? moment(this.maintenance.deadlineAt).format('DD/MM/YYYY HH:mm') : 'MAINTENANCES.TABS.DEADLINES.WITHOUT_DEADLINE';
        this.closedAt = this.maintenance.closedAt ? moment(this.maintenance.closedAt).format('DD/MM/YYYY HH:mm') : 'MAINTENANCES.TABS.DEADLINES.NOT_COMPLETED';
        if ((!this.maintenance.firstVisitDeadlineAt && !this.maintenance.firstVisitStartedAt) || (!this.maintenance.firstVisitDeadlineAt && this.maintenance.firstVisitStartedAt)) {
            this.colorMessageFirstVisitDeadline = '#AAAAAA';
            this.firstVisitDeadLineMessage = 'MAINTENANCES.TABS.DEADLINES.WITHOUT_DEADLINE';
        }
        if ((!this.maintenance.deadlineAt && !this.maintenance.closedAt) || (!this.maintenance.deadlineAt && this.maintenance.closedAt)) {
            this.colorMessageClosedDeadline = '#AAAAAA';
            this.closedDeadlineMessage = 'MAINTENANCES.TABS.DEADLINES.WITHOUT_DEADLINE';
        }
        if (!this.maintenance.deadlineAt && !this.maintenance.closedAt && !this.maintenance.firstVisitDeadlineAt && !this.maintenance.firstVisitStartedAt) {
            this.isAllDatesAsNull = true;
        }
        if (this.maintenance.firstVisitDeadlineAt && this.maintenance.firstVisitStartedAt) {
            if (moment(this.maintenance.firstVisitDeadlineAt).isAfter(this.maintenance.firstVisitStartedAt)) {
                this.colorMessageFirstVisitDeadline = '#12b886';
                this.firstVisitDeadLineMessage = 'MAINTENANCES.TABS.DEADLINES.ON_PERIOD_DELAYED_FIRST_VISIT';
            }
            else {
                this.colorMessageFirstVisitDeadline = '#ff3365';
                this.firstVisitDeadLineMessage = 'MAINTENANCES.TABS.DEADLINES.DELAYED_FIRST_VISIT';
            }
        }
        if (this.maintenance.deadlineAt && this.maintenance.closedAt) {
            if (moment(this.maintenance.deadlineAt).isAfter(this.maintenance.closedAt)) {
                this.colorMessageClosedDeadline = '#12b886';
                this.closedDeadlineMessage = 'MAINTENANCES.TABS.DEADLINES.ON_PERIOD_DELAYED_DEADLINE';
            }
            else {
                this.colorMessageClosedDeadline = '#ff3365';
                this.closedDeadlineMessage = 'MAINTENANCES.TABS.DEADLINES.DELAYED_DEADLINE';
            }
        }
        if (this.maintenance.firstVisitDeadlineAt && !this.maintenance.firstVisitStartedAt) {
            if (moment(this.maintenance.firstVisitDeadlineAt).isAfter(this.today)) {
                this.colorMessageFirstVisitDeadline = '#12b886';
                this.firstVisitDeadLineMessage = 'MAINTENANCES.TABS.DEADLINES.ON_PERIOD_DELAYED_FIRST_VISIT';
            }
            else {
                this.colorMessageFirstVisitDeadline = '#ff3365';
                this.firstVisitDeadLineMessage = 'MAINTENANCES.TABS.DEADLINES.DELAYED_FIRST_VISIT';
            }
        }
        if (this.maintenance.deadlineAt && !this.maintenance.closedAt) {
            if (moment(this.maintenance.deadlineAt).isAfter(this.today)) {
                this.colorMessageClosedDeadline = '#12b886';
                this.closedDeadlineMessage = 'MAINTENANCES.TABS.DEADLINES.ON_PERIOD_DELAYED_DEADLINE';
            }
            else {
                this.colorMessageClosedDeadline = '#ff3365';
                this.closedDeadlineMessage = 'MAINTENANCES.TABS.DEADLINES.DELAYED_DEADLINE';
            }
        }
    };
    return TabDeadlineComponent;
}());
export { TabDeadlineComponent };
